import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import LoginForm from './components/auth/LoginForm';
import RegisterForm from './components/auth/RegisterForm';
import VerifyEmail from './components/auth/VerifyEmail';
import UserForm from './components/lab/UserForm';
import Lab from './components/lab/Lab';
import LabOld from './components/lab/LabOld';
import Home from './components/lab/Home';
import Wallet from './components/wallet/Wallet';
import PrivateRoute from './PrivateRoute';
import PrivateUserRoute from './PrivateUserRoute';
import Computation from './components/lab/Computation'
import PredictionNew from './components/lab/PredictionNew';
import DetailsResultsAnal from './components/lab/DetailsResultsAnal';
import ChooseSubstance from './components/lab/ChooseSubstance';
import ModelsInfo from './components/lab/ModelsInfo';
import Summary from './components/lab/Summary';
import OldSummary from './components/lab/OldSummary';
import ChooseModelOld from './components/lab/ChooseModelOld';
import DefineEndpoints from './components/lab/DefineEndpoints';
import DefineNanoform from './components/lab/DefineNanoform';
import myIcon from './components/lab/images/favicon.ico';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import Contact from './components/lab/Contact';
import CalculatingPrediction from './components/lab/CalculatingPrediction';
import ManageLicences from './components/wallet/ManageLicences';
import './App.css';
import UserDetailsAdmin from './components/lab/UserDetailsAdmin';
import AddLicenseAdmin from './components/wallet/AddLicenseAdmin';
import ManageModelsAdmin from './components/models/ManageModelsAdmin';
import ManageModelDetails from './components/models/ManageModelDetails';
import EditModelAdmin from './components/models/EditModelAdmin';
import CreateModelAdmin from './components/models/CreateModelAdmin';
import CreateVersionAdmin from './components/models/CreateVersionAdmin';


function App() {
  const [isCollapsed, setIsCollapsed] = useState(false);

  useEffect(() => {
    const link = document.querySelector("link[rel~='icon']");
    if (link) {
      link.href = myIcon;
    } else {
      const newLink = document.createElement("link");
      newLink.rel = "icon";
      newLink.href = myIcon;
      document.head.appendChild(newLink);
    }
  }, []);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<Navigate to="/laboratory" replace />} />
          <Route path="/login" element={<LoginForm />} />
          <Route path="/register" element={<RegisterForm />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/user-form" element={<PrivateUserRoute element={UserForm} />} />
          <Route path="/home" element={<PrivateRoute element={Home} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/choose-substance" element={<PrivateRoute element={ChooseSubstance} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/models-info" element={<PrivateRoute element={ModelsInfo} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/wallet" element={<PrivateRoute element={Wallet} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/laboratory-old" element={<PrivateRoute element={LabOld} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/laboratory" element={<PrivateRoute element={Lab} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/new-pred/:analysisPk?" element={<PrivateRoute element={PredictionNew} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/laboratory/summary/:pk" element={<PrivateRoute element={OldSummary} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/laboratory/computation/:pk" element={<PrivateRoute element={Computation} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/laboratory/results/:pk" element={<PrivateRoute element={DetailsResultsAnal} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route
            path="/choose-model/:endpointPk/:analysisPk?"
            element={<PrivateRoute element={ChooseModelOld} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />}
          />
          <Route
            path="/define-endpoints"
            element={<PrivateRoute element={DefineEndpoints} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />}
          />
          <Route
            path="/define-nanoform"
            element={<PrivateRoute element={DefineNanoform} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />}
          />
          <Route
            path="/summary/:pk"
            element={<PrivateRoute element={Summary} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />}
          />
          <Route path="/contact" element={<PrivateRoute element={Contact} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/calculating-prediction/:pk" element={<PrivateRoute element={CalculatingPrediction} isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />} />
          <Route path="/manage-licences" element={<PrivateRoute element={ManageLicences} />} />
          <Route path="/manage-licences/:id" element={<PrivateRoute element={UserDetailsAdmin} />} />
          <Route path="/manage-licences/:id/add-license" element={<PrivateRoute element={AddLicenseAdmin} />} />
          <Route path="/manage-models" element={<PrivateRoute element={ManageModelsAdmin} />} />
          <Route path="/manage-models/:modelId" element={<PrivateRoute element={ManageModelDetails} />} />
          <Route path="/manage-models/:modelId/edit" element={<PrivateRoute element={EditModelAdmin} />} />
          <Route path="/manage-models/create" element={<PrivateRoute element={CreateModelAdmin} />} />
          <Route path="/manage-models/:modelId/new-version" element={<PrivateRoute element={CreateVersionAdmin} />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
